var map = {
	"sap/m/App": 342,
	"sap/m/Bar": 52,
	"sap/m/Button": 19,
	"sap/m/CustomListItem": 365,
	"sap/m/Input": 350,
	"sap/m/Label": 117,
	"sap/m/List": 223,
	"sap/m/Page": 344,
	"sap/m/SearchField": 205,
	"sap/m/SegmentedButton": 366,
	"sap/m/SegmentedButtonItem": 367,
	"sap/m/Shell": 341,
	"sap/m/Toolbar": 77,
	"sap/ui/core/library": 3,
	"sap/ui/model/json/JSONModel": 62,
	"sap/ui/model/resource/ResourceModel": 86
};
function openui5DynamicDep(req, failOnError) {
  var id = openui5DynamicDepResolve(req, failOnError);
  if (id === null) {
    return null;
  }
  if(!__webpack_require__.m[id])
    throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
  return __webpack_require__(id);
};
function openui5DynamicDepResolve(req, failOnError) {
  var id = map[req];
  if(!(id + 1)) { // check for number or string
    if (failOnError) {
      throw new Error("Cannot find module '" + req + "'.");
    }
    return null;
  }
  return id;
};
openui5DynamicDep.keys = function openui5DynamicDepKeys() {
  return Object.keys(map);
};
openui5DynamicDep.resolve = openui5DynamicDepResolve;
openui5DynamicDep.id = 429;
module.exports = openui5DynamicDep;